export default __webpack_public_path__ + "static/header-logo-6f6a1be5ca005edd9ecac633611772b4.svg";